import React from "react";
import classes from "./styles.module.css";
import { Button, Card, Grid, Image } from "antd";
import { Link } from "react-router-dom";
import QuixLogo from "assets/Logo.png";
import { VacationAlert } from "components/vacationBanner";

type Props = {
  children: React.ReactNode;
  heading: string;
  subHeading?: string;
  footerText?: string;
  footerLink?: string;
  footerLinkText?: string;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
};

const AuthScreenContainer = ({
  children,
  heading,
  subHeading,
  footerText,
  footerLink,
  footerLinkText,
  style,
  contentStyle
}: Props) => {
  const { sm } = Grid.useBreakpoint();

  return (
    <>
      <VacationAlert />
      <div style={style} className={classes.container}>
        {/* Quix Image */}
        <div className={classes.logoContainer}>
          <Image src={QuixLogo} alt="Quix Logo" preview={false} />
        </div>

        <Card
          style={{
            backgroundColor: "#283583",
            border: 0,
            borderRadius: "16px",
            padding: "40px 32px",
            maxWidth: "100%",
            ...contentStyle,
            width: sm ? "514px" : "90%"
          }}
          styles={{
            body: {
              padding: 0
            }
          }}>
          <p className={classes.heading}>{heading}</p>
          <p className={classes.subHeading}>{subHeading}</p>

          {children}
        </Card>

        <div className={classes.footerContainer}>
          <p style={{ color: "#FBF1F1" }} className={classes.footerText}>
            {footerText}
          </p>
          {footerLink && (
            <Button style={{ color: "#FF5A17", padding: 0 }} type="link">
              <Link to={footerLink} className={classes.footerLink}>
                {footerLinkText}
              </Link>
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default AuthScreenContainer;
